import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { translate } from '../../../Services/translation';
import WishListAdd from '../../WishList.add';

const VariantListItem = ({
  variant,
  showAddWishlist,
  setShowAddWishlist,
  quantities,
  setQuantities,
  handleQuantityChange,
  isOrderItem,
	displayPriceOnVariants
}) => {
  const ref = useRef();

  function getValue() {
    return parseInt(
      quantities.find((x) => x.articleNumber === variant.variantId)?.quantity ||
        0
    );
  }

  function decrement() {
    if (getValue() - variant.minQuantity >= 0) {
      handleQuantityChange(variant.variantId, getValue() - variant.minQuantity);
    }
  }

  function increment() {
		if (isOrderItem) {
			handleQuantityChange(variant.variantId, getValue() + variant.minQuantity);
		}
    else if (getValue() + variant.minQuantity <= variant.stockQuantity) {
      handleQuantityChange(variant.variantId, getValue() + variant.minQuantity);
    }
  }

  function handleChange(event) {
    handleQuantityChange(variant.variantId, String(Number(event.target.value)));
  }

  return (
    <React.Fragment key={variant.variantId}>
      <div className="product-body__item" style={{display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center"}}>
        <div>
          {variant.variantName}
          {variant.purchaseDate && (
            <p className="product-body__item-full-line">
              {translate(
                'product.purchasedate',
                variant.purchaseDate,
                variant.purchaseAmount
              )}
            </p>
          )}
        </div>
        {displayPriceOnVariants && (
          <div style={{fontWeight: '400', fontSize: '14px'}}>
            {variant.price.formattedPrice}
          </div>
        )}
        
      </div>
      <div
        className={`product-body__item product__stock-status ${
          isOrderItem
            ? ' product-detail__stock-status--pre-order'
            : variant.isInStock
            ? ''
            : ' product__stock-status--out-of-stock'
        }`}
      >
        {isOrderItem
          ? translate('pdp.stock.preorder')
          : variant.isInStock
          ? `${variant.stockQuantity} ${translate('pdp.stock.quantity')}`
          : `${translate('pdp.stock.out')}`}
      </div>
      <div className="product-body__item">
        {(variant.isInStock || isOrderItem) &&
          (variant.minQuantity > 1 ? (
            <div
              className="product-body__item-min-quantity-container"
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {variant.minQuantity > 1 && (
                <button
                  style={{ width: 40, height: 40 }}
                  className="product-body__item-min-quantity-button"
                  onClick={() => decrement()}
                >
                  -
                </button>
              )}

              <p
                ref={ref}
                className="product-body__item-min-quantity-input"
                onChange={handleChange}
              >
                {getValue()}
              </p>

              {variant.minQuantity > 1 && (
                <button
                  style={{ width: 40, height: 40 }}
                  className="product-body__item-min-quantity-button"
                  onClick={() => increment()}
                >
                  +
                </button>
              )}
            </div>
          ) : (
            <input
              ref={ref}
              className="product-body__item-input"
              type="number"
              id={`quantity_${variant.variantId}`}
              value={
                quantities.find((x) => x.articleNumber === variant.variantId)
                  ?.quantity || 0
              }
              onChange={handleChange}
              min={0}
              max={6969}
            />
          ))}
        <div
          className="wishlist-button product-body__item__wishlist"
          onClick={() => {
            showAddWishlist == null
              ? setShowAddWishlist(variant.variantId)
              : setShowAddWishlist(null);
          }}
        ></div>
        {showAddWishlist === variant.variantId && (
          <WishListAdd
            onClose={() => {
              setShowAddWishlist(null);
            }}
            articleNumber={variant.variantId}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default VariantListItem;
